import css from 'styled-jsx/css';

const GoogleAdsStyles = css`
  margin-top: 1px;
  width: fit-content;
  margin: auto;
`;

export default GoogleAdsStyles;
